/** Copyright (c) 2023 T. Rowe Price. All rights reserved. */

import './BeaconNewUserForm.scss';

import { func, object, string, bool } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  GrantViewAccessForm,
  GrantViewAccessFormV2,
} from 'services/Content';
import { AAMBeaconControl, AAMBeaconError } from 'components/shared/Beacon';
import { getIsRateLimitError, isNoEligibleAccountsError } from 'state/grantViewAccess/GrantViewAccessSelectors';
import { gvaNewCopyEnabled } from 'services/FeatureFlags';

const BeaconNewUserForm = ({
  firstName,
  birthDate,
  lastName,
  ssn,
  updateFirstName,
  updateLastName,
  updateDateofBirth,
  updateSSN,
  rateLimitError,
  isInvalidUserInput,
  NoEligibleAccountsError
}) => {

  return (
    <Fragment>
      <div
        className="add-newBeacon-user-form-wrapper"
        data-testid="scrollable-modal-form">
        <div className="beacon-on-light b-padding-inline--macro--mini ">
          <div className="b-flex b-direction-column">
            <div className="b-grid" >
              <AAMBeaconControl className='b-grid-item--6-col b-sm:12-col b-md:6-col name-class'>
                <label htmlFor="first-name" slot="label">First name</label>
                <input type="text"
                  name="firstName"
                  id="first-name"
                  value={firstName}
                  required={true}
                  pattern="^[A-Za-z0-9]+[ A-Za-z0-9\-_\.,'&]*$"
                  onChange={updateFirstName}
                  minLength="2" />
              </AAMBeaconControl>
              <AAMBeaconControl className='b-grid-item--6-col b-sm:12-col b-md:6-col name-class'>
                <label slot="label" htmlFor="last-name">Last name</label>
                <input type="text"
                  id="last-name"
                  name="lastName"
                  value={lastName}
                  required={true}
                  onChange={updateLastName}
                  pattern="^[A-Za-z0-9]+[ A-Za-z0-9\-_\.,'&]*$"
                  minLength="2" />
              </AAMBeaconControl>
            </div>

            <div className="b-flex b-direction-row" >
              <AAMBeaconControl>
                <label htmlFor="date-picker" slot="label">Date of birth</label>
                <input type="date"
                  name="Date of birth"
                  id="date-picker"
                  value={birthDate}
                  required={true}
                  onChange={updateDateofBirth}
                  max={moment().format('YYYY-MM-DD')} />
              </AAMBeaconControl>
            </div>
            <div className="b-flex b-direction-row" >
              <AAMBeaconControl className='ssn-class'>
                <label slot="label" htmlFor="gva-taxId">Social Security number
                  <br />
                  <span className="b-typography-sans-serif--body--100 b-font-weight-light">Last 4 digits</span></label>
                <input type="text"
                  id="gva-taxId"
                  name="Social Security number"
                  value={ssn || ''}
                  minLength="4"
                  maxLength="4"
                  required={true}
                  onChange={updateSSN}
                  pattern="\d{4}" />
              </AAMBeaconControl>
            </div>
          </div>
        </div>



        <p className="newBeacon-user-requirement-copy">
          {gvaNewCopyEnabled() ? GrantViewAccessFormV2.RequirementCopy : GrantViewAccessForm.RequirementCopy}
        </p>
        <div className="separator" />
        <p className="new-user-disclosures">
          {gvaNewCopyEnabled() ? GrantViewAccessFormV2.CustomerAgreement : GrantViewAccessForm.CustomerAgreement}
        </p>
      </div>
      {
        rateLimitError && (
          <div className="new-user-modal-rate-error">
            <AAMBeaconError>
              <span>
                {gvaNewCopyEnabled() ? GrantViewAccessFormV2.RateLimitError : GrantViewAccessForm.RateLimitError}
              </span>
            </AAMBeaconError>
          </div>
        )
      }
      {
        NoEligibleAccountsError && (
          <div className="new-user-modal-rate-error">
            <AAMBeaconError>
              <span>
                {gvaNewCopyEnabled() ? GrantViewAccessFormV2.NoEligibleAccounts : GrantViewAccessForm.NoEligibleAccounts}
              </span>
            </AAMBeaconError>
          </div>
        )
      }
      {
        !rateLimitError && isInvalidUserInput && (
          <div className="new-user-modal-rate-error">
            <AAMBeaconError
              id="beacon-error"
            >
              <span>
                {gvaNewCopyEnabled() ? GrantViewAccessFormV2.AuthDeniedMsg : GrantViewAccessForm.AuthDeniedMsg}
              </span>
            </AAMBeaconError>
          </div>
        )
      }
    </Fragment >
  );
};

BeaconNewUserForm.propTypes = {
  firstName: string,
  invalidFields: object,
  lastName: string,
  onClose: func,
  onContinue: func,
  shouldDisableNext: bool,
  birthDate: string,
  ssn: string,
  touchedFields: object,
  updateFirstName: func,
  updateLastName: func,
  updateDateOfBirth: func,
  updateSSN: func,
  isInvalidUserInput: bool,
  NoEligibleAccountsError: bool,
};

const mapStateToProps = (state) => ({
  invalidFields: state.invalidFields,
  touchedFields: state.touchedFields,
  rateLimitError: getIsRateLimitError(state),
  NoEligibleAccountsError: isNoEligibleAccountsError(state)
});

export default connect(mapStateToProps)(BeaconNewUserForm);
